import NotificationBody from '../components/Notification';
function Notification() {
  return (
    <NotificationBody/>
  )
}

export default Notification;